// Auto-generated from solutions-builders.html. Verbatim redesign import. Do NOT edit.
export const SCRIPT = `
(function(){
  // hero constellation canvas (lives outside .ix-scope)
  var cv=document.getElementById('bldHeroCanvas');
  var reducedH=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(cv && !reducedH){
    var ctx=cv.getContext('2d'), W,H,DPR,nodes,hubs,raf2,t=0,running2=false;
    function size(){ DPR=Math.min(window.devicePixelRatio||1,2); var r=cv.getBoundingClientRect(); W=r.width;H=r.height; cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0); }
    function build(){ var n=Math.round(Math.min(96,Math.max(40,W/18))); nodes=[]; for(var i=0;i<n;i++){ nodes.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.20,vy:(Math.random()-0.5)*0.20,r:Math.random()*1.8+0.8}); }
      // a few hub nodes: larger, with a pulsing halo, anchored loosely
      hubs=[]; var hn=Math.max(3,Math.round(W/520));
      for(var h=0;h<hn;h++){ hubs.push({x:(0.12+0.76*Math.random())*W,y:(0.16+0.7*Math.random())*H,vx:(Math.random()-0.5)*0.08,vy:(Math.random()-0.5)*0.08,ph:Math.random()*Math.PI*2}); } }
    var LINK=190;
    function frame(){ t+=0.004; ctx.clearRect(0,0,W,H);
      for(var i=0;i<nodes.length;i++){ var p=nodes[i]; p.x+=p.vx;p.y+=p.vy;
        if(p.x<0||p.x>W)p.vx*=-1; if(p.y<0||p.y>H)p.vy*=-1; }
      for(var hh=0;hh<hubs.length;hh++){ var hb=hubs[hh]; hb.x+=hb.vx; hb.y+=hb.vy; if(hb.x<0||hb.x>W)hb.vx*=-1; if(hb.y<0||hb.y>H)hb.vy*=-1; }
      // links (peer nodes) — more visible
      for(var a=0;a<nodes.length;a++){ for(var b=a+1;b<nodes.length;b++){ var dx=nodes[a].x-nodes[b].x,dy=nodes[a].y-nodes[b].y,d=Math.sqrt(dx*dx+dy*dy);
        if(d<LINK){ var al=(1-d/LINK)*0.34; ctx.strokeStyle='rgba(21,16,42,'+al.toFixed(3)+')'; ctx.lineWidth=0.7; ctx.beginPath(); ctx.moveTo(nodes[a].x,nodes[a].y); ctx.lineTo(nodes[b].x,nodes[b].y); ctx.stroke();
          // occasional travelling pulse along the link (deterministic per pair so it's stable)
          var seed=(a*7+b*13)%17; var pp=((t*0.4)+seed/17)%1;
          if(d<LINK*0.85){ var px=nodes[a].x+(nodes[b].x-nodes[a].x)*pp, py=nodes[a].y+(nodes[b].y-nodes[a].y)*pp; var pa=(1-d/LINK)*Math.sin(pp*Math.PI)*0.5;
            ctx.fillStyle='rgba(255,122,51,'+pa.toFixed(3)+')'; ctx.beginPath(); ctx.arc(px,py,1.4,0,Math.PI*2); ctx.fill(); } } } }
      // hub halos + connections from hubs to nearby nodes (champagne, brighter)
      for(var g=0;g<hubs.length;g++){ var H0=hubs[g], pulse0=0.5+0.5*Math.sin(t*2.2+H0.ph);
        for(var m=0;m<nodes.length;m++){ var ddx=H0.x-nodes[m].x,ddy=H0.y-nodes[m].y,dd=Math.sqrt(ddx*ddx+ddy*ddy);
          if(dd<LINK*1.15){ var hal=(1-dd/(LINK*1.15))*0.24; ctx.strokeStyle='rgba(168,139,74,'+hal.toFixed(3)+')'; ctx.lineWidth=0.8; ctx.beginPath(); ctx.moveTo(H0.x,H0.y); ctx.lineTo(nodes[m].x,nodes[m].y); ctx.stroke(); } }
        ctx.fillStyle='rgba(168,139,74,'+(0.55+pulse0*0.22).toFixed(3)+')'; ctx.beginPath(); ctx.arc(H0.x,H0.y,2.4+pulse0*1.0,0,Math.PI*2); ctx.fill(); }
      // nodes
      for(var k=0;k<nodes.length;k++){ var q=nodes[k], pulse=0.5+0.5*Math.sin(t*6+k); ctx.fillStyle='rgba(168,139,74,'+(0.30+pulse*0.26).toFixed(3)+')'; ctx.beginPath(); ctx.arc(q.x,q.y,q.r,0,Math.PI*2); ctx.fill(); }
      if(running2) raf2=requestAnimationFrame(frame);
    }
    function start2(){ if(running2)return; running2=true; raf2=requestAnimationFrame(frame); }
    function stop2(){ running2=false; cancelAnimationFrame(raf2); }
    size(); build(); start2();
    window.addEventListener('resize',function(){ size(); build(); });
    if('IntersectionObserver' in window){ var hio=new IntersectionObserver(function(es){es.forEach(function(e){ e.isIntersecting?start2():stop2(); });},{threshold:0.01}); hio.observe(cv); }
  }
  // cycling role word in the hero headline (crossfade swap, no visible scroll)
  (function(){
    var roles=["credit protocol","repo market","trading venue","settlement rail","collateral engine","issuance app"];
    var track=document.getElementById('bldCycTrack'), wrap=document.getElementById('bldCyc'), measure=document.getElementById('bldCycMeasure');
    if(!track||!wrap||!measure) return;
    var spans=roles.map(function(w){ var s=document.createElement('span'); s.className='w'; s.textContent=w; track.appendChild(s); return s; });
    var idx=0;
    function syncMeasureFont(){
      // Copy the visible .w's font metrics onto the measure element so its
      // width matches exactly. Only copying font-size (as before) missed
      // font-family and weight, so italic words like "repo market" clipped.
      var probe = spans[0]; if(!probe) return;
      var cs = getComputedStyle(probe);
      measure.style.fontSize = cs.fontSize;
      measure.style.fontFamily = cs.fontFamily;
      measure.style.fontWeight = cs.fontWeight;
      measure.style.fontStyle = cs.fontStyle;
      measure.style.letterSpacing = cs.letterSpacing;
      measure.style.padding = cs.padding;
    }
    function measureWord(w){ syncMeasureFont(); measure.textContent=w; return measure.getBoundingClientRect().width; }
    function setWidth(w){ if(window.matchMedia('(max-width: 760px)').matches){ wrap.style.width=''; return; } wrap.style.width=(Math.ceil(measureWord(w))+10)+'px'; }
    function show(i){ spans.forEach(function(s,k){ s.classList.remove('is-in','is-out'); if(k===i) s.classList.add('is-in'); }); setWidth(roles[i]); }
    show(0); window.addEventListener('load',function(){ setWidth(roles[idx]); }); window.addEventListener('resize',function(){ setWidth(roles[idx]); });
    // Fonts often load AFTER first paint — reflow the width once webfonts settle.
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function(){ setWidth(roles[idx]); }); }
    var reducedC=window.matchMedia('(prefers-reduced-motion: reduce)').matches; if(reducedC) return;
    setInterval(function(){
      var prev=idx; idx=(idx+1)%roles.length;
      spans[prev].classList.remove('is-in'); spans[prev].classList.add('is-out');
      spans[idx].classList.remove('is-out'); spans[idx].classList.add('is-in');
      setWidth(roles[idx]);
    },2600);
  })();
  var root=document.querySelector('.view[data-route="/solutions/builders"] .ix-scope')||document.querySelector('.ix-scope'); if(!root) return;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ups=root.querySelectorAll('.reveal-up');
  if('IntersectionObserver' in window && !reduced){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });},{threshold:0.18,rootMargin:'0px 0px -8% 0px'});
    ups.forEach(function(el){io.observe(el);});
  } else { ups.forEach(function(el){el.classList.add('in');}); }
  var steps=root.querySelector('#bldSteps');
  if(steps){
    var items=steps.querySelectorAll('.ix-step');
    function setActive(idx){
      items.forEach(function(it,i){
        it.classList.toggle('active', i===idx);
        it.classList.toggle('done', i<idx);
      });
    }
    items.forEach(function(it,i){
      it.addEventListener('mouseenter',function(){ setActive(i); });
      it.addEventListener('focusin',function(){ setActive(i); });
    });
    steps.addEventListener('mouseleave',function(){ items.forEach(function(it){ it.classList.remove('active','done'); }); });
  }
  // future carousel: horizontal slider with prev/next; leading visible card gets the champagne look
  var fcar=root.querySelector('#bldFcar');
  var fvp=root.querySelector('#bldFcarVp');
  if(fcar && fvp){
    var cards=Array.prototype.slice.call(fcar.querySelectorAll('.ix-fc'));
    var prev=document.getElementById('bldFprev'), next=document.getElementById('bldFnext');
    var idx=0;
    function step(){ // card width + gap
      if(cards.length<2) return cards.length?cards[0].getBoundingClientRect().width:0;
      return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    }
    function maxIdx(){
      var vpw=fvp.getBoundingClientRect().width, s=step();
      if(s<=0) return 0;
      var total=fcar.scrollWidth;
      var m=Math.ceil((total - vpw)/s - 0.02);
      return Math.max(0, Math.min(cards.length-1, m));
    }
    function clamp(n){ var m=maxIdx(); return Math.max(0, Math.min(m, n)); }
    function render(){
      idx=clamp(idx);
      var s=step();
      fcar.style.transform='translateX('+(-idx*s)+'px)';
      cards.forEach(function(c,i){ c.classList.toggle('lead', i===idx); });
      if(prev) prev.disabled = idx<=0;
      if(next) next.disabled = idx>=maxIdx();
    }
    if(prev) prev.addEventListener('click',function(){ idx--; render(); });
    if(next) next.addEventListener('click',function(){ idx++; render(); });

    // pointer drag
    var dragging=false, startX=0, startTx=0, moved=0, s0=0;
    function curTx(){ var s=step(); return -idx*s; }
    fcar.addEventListener('pointerdown',function(e){
      if(e.button && e.button!==0) return;
      dragging=true; moved=0; startX=e.clientX; startTx=curTx(); s0=step();
      fcar.classList.add('is-dragging');
      try{ fcar.setPointerCapture(e.pointerId); }catch(_){}
    });
    fcar.addEventListener('pointermove',function(e){
      if(!dragging) return;
      var dx=e.clientX-startX; moved=Math.abs(dx);
      // rubber-band clamp so you can't drag far past the ends
      var m=maxIdx(), minTx=-m*s0, maxTx=0;
      var tx=startTx+dx;
      if(tx>maxTx) tx=maxTx+(tx-maxTx)*0.35;
      if(tx<minTx) tx=minTx+(tx-minTx)*0.35;
      fcar.style.transform='translateX('+tx+'px)';
    });
    function endDrag(e){
      if(!dragging) return; dragging=false;
      fcar.classList.remove('is-dragging');
      try{ fcar.releasePointerCapture(e.pointerId); }catch(_){}
      var dx=e.clientX-startX, s=step();
      if(s>0 && Math.abs(dx)>s*0.18){ idx=clamp(idx - Math.round(dx/s)); }
      render();
    }
    fcar.addEventListener('pointerup',endDrag);
    fcar.addEventListener('pointercancel',endDrag);
    // click a card to lead it, but ignore the click that ends a real drag
    cards.forEach(function(c,i){ c.addEventListener('click',function(){ if(moved>6) return; idx=i; render(); }); });

    var rt; window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(render,120); });
    render();
  }
  // <<<GR_START>>> builders: build once, run everywhere (integration plug -> fan-out)
  (function(){
    var view=document.querySelector('.view[data-route="/solutions/builders"]')||document;
    var stage=view.querySelector('#bldGrStage'); if(!stage) return;
    var cv=view.querySelector('#bldPlugCanvas'); if(!cv) return;
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ctx=cv.getContext('2d'), W,H,DPR,plugX,plugY,S;
    var LAVA='255,122,51', CHAMP='168,139,74';
    // destinations fanned across the right; fan vertical spread scales with height
    var N=6, dest=[];
    function size(){ DPR=Math.min(window.devicePixelRatio||1,2); W=cv.clientWidth;H=cv.clientHeight;
      cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0);
      S=Math.min(W/620,H/520); if(S<=0||!isFinite(S))S=1;
      plugX=W*0.34; plugY=H/2;
      dest=[];
      var rightX=W*0.92, top=H*0.12, bot=H*0.88;
      for(var j=0;j<N;j++){ var fy=N>1?(j/(N-1)):0.5; dest.push({x:rightX, y:top+(bot-top)*fy, ph:Math.random()}); }
    }
    window.addEventListener('resize',size); size();
    var run=false, raf=0, t0=performance.now(), appear=0;
    function eo(x){ return 1-Math.pow(1-x,3); }
    // cubic bezier point from plug edge to a destination
    function bez(d,t){ var x1=plugX+24*S,y1=plugY, x2=plugX+120*S,y2=plugY, x3=d.x-120*S,y3=d.y, x4=d.x,y4=d.y;
      var mt=1-t; return [mt*mt*mt*x1+3*mt*mt*t*x2+3*mt*t*t*x3+t*t*t*x4, mt*mt*mt*y1+3*mt*mt*t*y2+3*mt*t*t*y3+t*t*t*y4]; }
    function frame(now){
      var t=(now-t0)*0.001; ctx.clearRect(0,0,W,H);
      appear=Math.min(1,appear+0.02); var ap=eo(appear);
      // 1) single source rail entering from the left (your one integration)
      var leftX=W*0.06;
      ctx.strokeStyle='rgba('+CHAMP+','+(0.72*ap)+')'; ctx.lineWidth=1.8;
      ctx.beginPath(); ctx.moveTo(leftX,plugY); ctx.lineTo(plugX-24*S,plugY); ctx.stroke();
      ctx.fillStyle='rgba('+CHAMP+','+(0.9*ap)+')'; ctx.beginPath(); ctx.arc(leftX,plugY,4.5*S,0,7); ctx.fill();
      ctx.textAlign='left'; ctx.textBaseline='middle';
      ctx.fillStyle='rgba(138,110,58,'+(0.95*ap)+')'; ctx.font='600 13px "JetBrains Mono", ui-monospace, monospace';
      ctx.fillText('ONE INTEGRATION', leftX, plugY-22*S);
      // 2) champagne fan: a soft bundle of curves around each destination (the spray, but elegant + champagne)
      dest.forEach(function(d){ for(var s=-2;s<=2;s++){ var off=s*9*S;
        var bend=(d.y-plugY)*0.5;
        var grad=ctx.createLinearGradient(plugX,plugY,d.x,d.y);
        var a0=(Math.abs(s)===2?0.05:Math.abs(s)===1?0.10:0.18)*ap;
        grad.addColorStop(0,'rgba('+CHAMP+','+(a0)+')'); grad.addColorStop(0.7,'rgba('+CHAMP+','+(a0*0.7)+')'); grad.addColorStop(1,'rgba('+CHAMP+',0)');
        ctx.strokeStyle=grad; ctx.lineWidth=0.7; ctx.beginPath();
        ctx.moveTo(plugX+22*S,plugY+off*0.2);
        ctx.bezierCurveTo(plugX+120*S,plugY+bend+off, d.x-140*S,d.y+off, d.x-12*S,d.y); ctx.stroke(); } });
      // 3) the defined champagne route to each destination (brighter, the clear paths)
      dest.forEach(function(d){ var grad=ctx.createLinearGradient(plugX,plugY,d.x,d.y);
        grad.addColorStop(0,'rgba('+CHAMP+','+(0.55*ap)+')'); grad.addColorStop(1,'rgba('+CHAMP+','+(0.32*ap)+')');
        ctx.strokeStyle=grad; ctx.lineWidth=1.1; ctx.beginPath();
        ctx.moveTo(plugX+24*S,plugY); ctx.bezierCurveTo(plugX+120*S,plugY, d.x-120*S,d.y, d.x,d.y); ctx.stroke(); });
      // 4) the packet: travels in along the rail, then continuously streams out to all destinations
      var inDur=0.32, cyc=(t*0.4)%1;
      if(cyc<inDur){ var p=cyc/inDur, px=leftX+(plugX-24*S-leftX)*eo(p), f=Math.sin(p*Math.PI);
        ctx.fillStyle='rgba('+LAVA+','+ap+')'; ctx.beginPath(); ctx.arc(px,plugY,(2.6+1.2*f)*S,0,7); ctx.fill(); }
      // packets flowing outward along every curve (staggered, always present after the intro) — lava does the talking
      dest.forEach(function(d,k){ var pp=((t*0.55)+d.ph)%1; var pt=bez(d,pp); var f=Math.sin(pp*Math.PI);
        ctx.fillStyle='rgba('+LAVA+','+(ap*(0.5+0.5*f))+')'; ctx.beginPath(); ctx.arc(pt[0],pt[1],(2.2+1.2*f)*S,0,7); ctx.fill(); });
      // 5) destination chain-nodes as depth-sorted champagne cubes
      var ordered=dest.map(function(d,k){ var pulse=0.5+0.5*Math.sin(t*1.8+k); return {x:d.x,y:d.y,depth:pulse}; }).sort(function(a,b){return a.depth-b.depth;});
      ordered.forEach(function(o){ var depth=o.depth, sz=(11+depth*5)*S; ctx.save(); ctx.translate(o.x,o.y); ctx.rotate(Math.PI/4);
        ctx.fillStyle='rgba(254,252,248,'+(ap*(0.6+0.4*depth))+')'; ctx.strokeStyle='rgba('+CHAMP+','+(ap*(0.5+0.5*depth))+')'; ctx.lineWidth=1.2;
        ctx.fillRect(-sz/2,-sz/2,sz,sz); ctx.strokeRect(-sz/2,-sz/2,sz,sz); ctx.restore(); });
      // 6) the central plug: a glowing golden globe (same material as the orbital graphic)
      var R=26*S, spin=t*0.18;
      var halo=ctx.createRadialGradient(plugX,plugY,0,plugX,plugY,R*2.6);
      halo.addColorStop(0,'rgba(250,248,244,'+(0.85*ap)+')'); halo.addColorStop(0.45,'rgba(250,248,244,'+(0.32*ap)+')'); halo.addColorStop(1,'rgba(250,248,244,0)');
      ctx.fillStyle=halo; ctx.beginPath(); ctx.arc(plugX,plugY,R*2.6,0,7); ctx.fill();
      var glow=ctx.createRadialGradient(plugX,plugY,R*0.6,plugX,plugY,R*1.9);
      glow.addColorStop(0,'rgba(244,213,138,'+(0.42*ap)+')'); glow.addColorStop(1,'rgba(212,175,90,0)');
      ctx.fillStyle=glow; ctx.beginPath(); ctx.arc(plugX,plugY,R*1.9,0,7); ctx.fill();
      var sph=ctx.createRadialGradient(plugX-R*0.32,plugY-R*0.34,R*0.05,plugX,plugY,R);
      sph.addColorStop(0,'#FFF3D4'); sph.addColorStop(0.35,'#F4D58A'); sph.addColorStop(0.7,'#C9A24B'); sph.addColorStop(1,'#8A6B2E');
      ctx.fillStyle=sph; ctx.beginPath(); ctx.arc(plugX,plugY,R,0,7); ctx.fill();
      ctx.save(); ctx.beginPath(); ctx.arc(plugX,plugY,R-0.5,0,7); ctx.clip();
      for(var m=0;m<5;m++){ var phase=spin+m/5*Math.PI*2, cosp=Math.cos(phase), sinp=Math.sin(phase);
        ctx.strokeStyle='rgba(138,107,46,'+(0.12+0.4*Math.max(0,sinp))+')'; ctx.lineWidth=1;
        ctx.beginPath(); ctx.ellipse(plugX,plugY,Math.abs(cosp)*R,R,0,0,Math.PI*2); ctx.stroke(); }
      ctx.strokeStyle='rgba(138,107,46,0.28)'; ctx.beginPath(); ctx.ellipse(plugX,plugY,R,R*0.26,0,0,Math.PI*2); ctx.stroke();
      ctx.restore();
      ctx.strokeStyle='rgba(232,217,184,'+(0.8*ap)+')'; ctx.lineWidth=1; ctx.beginPath(); ctx.arc(plugX,plugY,R,0,7); ctx.stroke();
      var spec=ctx.createRadialGradient(plugX-R*0.34,plugY-R*0.36,0,plugX-R*0.34,plugY-R*0.36,R*0.55);
      spec.addColorStop(0,'rgba(255,252,244,0.85)'); spec.addColorStop(1,'rgba(255,252,244,0)');
      ctx.fillStyle=spec; ctx.beginPath(); ctx.arc(plugX-R*0.3,plugY-R*0.32,R*0.5,0,7); ctx.fill();
      // 7) label
      ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillStyle='rgba('+LAVA+','+(0.95*ap)+')'; ctx.font='10px "JetBrains Mono", ui-monospace, monospace';
      ctx.fillText('R U N   E V E R Y W H E R E', W/2, H-16);
      if(run && !reduced) raf=requestAnimationFrame(frame);
    }
    if(reduced){ appear=1; frame(performance.now()); return; }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){
        if(e.isIntersecting && !run){ run=true; raf=requestAnimationFrame(frame); }
        else if(!e.isIntersecting && run){ run=false; cancelAnimationFrame(raf); }
      });},{threshold:0.05}); io.observe(stage);
    } else { run=true; raf=requestAnimationFrame(frame); }
  })();
  // <<<GR_END>>>
  // <<<GR_END>>>
  var cnt=root.querySelector('.ix-count');
  if(cnt){
    var to=parseInt(cnt.getAttribute('data-to'),10)||100, done=false;
    function run(){ if(done) return; done=true; var t0=null;
      function tick(ts){ if(!t0)t0=ts; var p=Math.min(1,(ts-t0)/1100); var e=1-Math.pow(1-p,3);
        cnt.textContent=Math.round(to*e); if(p<1) requestAnimationFrame(tick); }
      requestAnimationFrame(tick);
    }
    if(reduced){ cnt.textContent=to; }
    else if('IntersectionObserver' in window){ var cio=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){run(); cio.unobserve(e.target);} });},{threshold:0.5}); cio.observe(cnt); }
    else run();
  }
})();
`;
